import React, { useState, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { APPLE_THEME, TYPOGRAPHY } from '../theme';

const Header = () => {
  const [scrolled, setScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
  const max = 120;
    let rafId;
    const update = () => {
      const y = Math.max(0, Math.min(window.scrollY || 0, max));
      const shrink = +(y / max).toFixed(4);
      document.documentElement.style.setProperty('--header-shrink', String(shrink));
      setScrolled(shrink > 0.02);
    };
    const onScroll = () => {
      cancelAnimationFrame(rafId);
      rafId = requestAnimationFrame(update);
    };
    update();
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => {
      window.removeEventListener('scroll', onScroll);
      cancelAnimationFrame(rafId);
      document.documentElement.style.setProperty('--header-shrink', '0');
    };
  }, []);

  const go = (path) => {
    if (location.pathname !== path) navigate(path);
    setMobileMenuOpen(false);
  };

  return (
    <>
      <nav
        className={`fixed top-0 left-0 right-0 z-50 transition-colors duration-500 ${scrolled ? 'bg-white/70 backdrop-blur-2xl border-b border-gray-200/60' : 'bg-transparent'}`}
        style={{ willChange: 'transform, height, background-color', transform: 'translateZ(0)' }}
      >
        <div className="max-w-7xl mx-auto px-6">
          <div className="flex items-center justify-between" style={{ height: 'var(--header-height)' }}>
            <div className="flex items-center">
              <button
                onClick={() => go('/')}
                className="text-2xl font-bold transition-opacity duration-200 hover:opacity-80"
                style={{
                  color: APPLE_THEME.black,
                  fontFamily: TYPOGRAPHY.hero,
                  transform: 'scale(var(--header-scale))',
                  transformOrigin: 'left center',
                  transition: 'transform 180ms ease'
                }}
              >
                C-Store
              </button>
            </div>

            <div className="hidden md:flex items-center space-x-8">
              <button
                onClick={() => go('/hizmetler')}
                className="text-sm hover:text-gray-600 transition-colors duration-200"
                style={{
                  color: APPLE_THEME.black,
                  fontFamily: TYPOGRAPHY.body
                }}
              >
                Hizmetler
              </button>

              <button
                onClick={() => go('/destek')}
                className="text-sm hover:text-gray-600 transition-colors duration-200"
                style={{
                  color: APPLE_THEME.black,
                  fontFamily: TYPOGRAPHY.body
                }}
              >
                Destek
              </button>
              <button
                onClick={() => go('/iletisim')}
                className="text-sm hover:text-gray-600 transition-colors duration-200"
                style={{
                  color: APPLE_THEME.black,
                  fontFamily: TYPOGRAPHY.body
                }}
              >
                İletişim
              </button>
            </div>

            <button
              className="hidden md:block px-4 py-2 rounded-full text-sm font-medium transition-all duration-200 hover:opacity-90"
              style={{
                backgroundColor: APPLE_THEME.darkMetalicGray,
                color: APPLE_THEME.white,
                fontFamily: TYPOGRAPHY.body,
                border: `1px solid ${APPLE_THEME.lightMetalicGray}`,
                boxShadow: '0 2px 8px rgba(0, 0, 0, 0.1)'
              }}
              onClick={() => go('/iletisim')}
            >
              Randevu Al
            </button>

            <button
              className="md:hidden"
              onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            >
              <svg
                className={`w-6 h-6 transition-transform duration-200 ${mobileMenuOpen ? 'rotate-90' : ''}`}
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
                style={{ color: APPLE_THEME.black }}
              >
                {mobileMenuOpen ? (
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                ) : (
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
                )}
              </svg>
            </button>
          </div>
        </div>
      </nav>

      {mobileMenuOpen && (
        <div className="fixed inset-0 z-40 md:hidden">
          <div
            className="absolute inset-0 bg-black bg-opacity-20 backdrop-blur-sm"
            onClick={() => setMobileMenuOpen(false)}
          />
          <div
            className="absolute top-14 left-0 right-0 bg-white bg-opacity-95 backdrop-blur-xl border-b border-gray-200"
          >
            <div className="px-6 py-8 space-y-6">
              <button
                className="block text-lg font-medium"
                style={{ color: APPLE_THEME.black, fontFamily: TYPOGRAPHY.body }}
                onClick={() => go('/hizmetler')}
              >
                Hizmetler
              </button>
              <button
                className="block text-lg font-medium"
                style={{ color: APPLE_THEME.black, fontFamily: TYPOGRAPHY.body }}
                onClick={() => go('/destek')}
              >
                Destek
              </button>
              <button
                className="block text-lg font-medium"
                style={{ color: APPLE_THEME.black, fontFamily: TYPOGRAPHY.body }}
                onClick={() => go('/iletisim')}
              >
                İletişim
              </button>

              <button
                className="w-full mt-6 px-6 py-3 rounded-full text-lg font-medium"
                style={{
                  backgroundColor: APPLE_THEME.blue,
                  color: APPLE_THEME.white,
                  fontFamily: TYPOGRAPHY.body
                }}
                onClick={() => go('/iletisim')}
              >
                Randevu Al
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default Header;